export default __webpack_public_path__ + "static/media/thumbnail3.ac6c41bc.jpg";